import type { MeetingPageResponse } from '@wundo/shared/meetingPage.ts';

/**
 * Whether the meeting is over: past its end, not merely started. The same
 * boundary the server draws when it refuses to write a preparation for a
 * meeting that already happened.
 */
export function meetingIsOver(page: MeetingPageResponse, now: Date): boolean {
  return new Date(page.meeting.ends_at).getTime() <= now.getTime();
}
